import React from "react";
import { compose } from "react-apollo";
import classnames from "classnames";
import { withStore } from "../../store";
import { withRouter } from "react-router-dom";
import ExternalLink from "../ExternalLink/ExternalLink";
import PerformanceActions from "../PerformanceActions/PerformanceActions";
import { SVG } from "../../assets/images";
import { getPageType, getComposerLastName } from "../../utils";
import "./PerformanceInfo.scss";
import { metUrl } from "../../config/metMainSite";

interface LinkItemProps {
  url: string;
  text?: string;
  image?: string;
  alt?: string;
  target?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
}

interface PerformanceInfoData {
  id: string;
  isFavorite?: boolean;
  header?: string;
  fullSynopsis?: string;
  briefSynopsis?: string;
  cast?: any[];
  ticketURL?: string;
  eventDate?: string;
}

interface PerformanceInfoProps {
  info: PerformanceInfoData;
  history?: any;
  store?: {
    user?: any;
  };
}

const LinkItem: React.FunctionComponent<LinkItemProps> = ({ url, text, image, alt, target, children, style }) => {
  return (
    <ExternalLink
      url={url}
      text={text}
      image={image}
      alt={alt}
      style={style}
      target={target}
    >
      {children}
    </ExternalLink>
  );
};

const PerformanceHeaderBlock: React.FunctionComponent<PerformanceInfoProps> = ({ info, history }) => {
  const { header, briefSynopsis, cast } = info;
  const composerLastName = getComposerLastName(cast);
  const pageType = getPageType();

  return (
    <div className={classnames("PerformanceInfo", pageType)}>
      <button type="button" className="back-btn" onClick={() => history && history.push("/")}>
        <SVG.BackArrow />
        <span>Back</span>
      </button>
      <div className="performance-header">
        <div className="performance-header-info">
          { composerLastName && <p className="performance-composer">{composerLastName}</p> }
          { header && <h1 className="performance-title">{header}</h1> }
        </div>
      </div>
      {briefSynopsis &&
        <div className="performance-body">
          <div className="performance-description" dangerouslySetInnerHTML={{ __html: briefSynopsis }} />
        </div>
      }
    </div>
  );
};

const PerformanceLongBlock: React.FunctionComponent<PerformanceInfoProps> = ({ info }) => {
  const { fullSynopsis, ticketURL } = info;
  const pageType = getPageType();

  if (!fullSynopsis) {
    return null;
  }

  return (
    <div className={classnames("PerformanceInfo", pageType)}>
      <div className="performance-body">

         
        <div className="performance-description" dangerouslySetInnerHTML={{ __html: fullSynopsis }} />
         <div className="actions-cta">
                <PerformanceActions showFavoriteAction={false}  />
                <LinkItem url={ticketURL || metUrl("/calendar")} style={{ textDecoration: "none" }}>
                  <button className="btn btn-pink" style={{ cursor: "pointer" }}><span>Buy Tickets</span></button>
                </LinkItem>
        </div>
        <div className="performance-header-cta footer">
          <PerformanceActions showFavoriteAction={false} />
          <LinkItem url={ticketURL || metUrl("/calendar")} style={{ textDecoration: "none" }}>
            <button className="btn btn-pink" style={{ cursor: "pointer" }}><span>Buy Tickets</span></button>
          </LinkItem>
        </div>
      </div>
    </div>
  );
};

const RadioPerformanceInfo = compose(withRouter, withStore)(PerformanceHeaderBlock);
const RadioPerformanceLongInfo = compose(withStore)(PerformanceLongBlock);

export { RadioPerformanceLongInfo, RadioPerformanceInfo };
export default RadioPerformanceInfo;
